export default {
  cardNumber: {
    presence: { allowEmpty: false }
  }
};
